import { render, staticRenderFns } from "./truckIn.vue?vue&type=template&id=1d1b2519&"
import script from "./truckIn.vue?vue&type=script&lang=js&"
export * from "./truckIn.vue?vue&type=script&lang=js&"
import style0 from "./truckIn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports